module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAOCAYAAAD0f5bSAAAAr0lEQVQokZ3QsW0CQRCF4Y8VseUAOnAGCZIbcBEEboBGqME9kBKRkCBSUsJ1SICwxCEiWwIC9sTprIM7XjL7Zuaf3dlWjFGF3jHDJ+bFQqgiMEAH43LhHvSR4ltdqIdhOh/qQK+YoJ38v6Xb5YTr0v3S4FHBf7dijBlesEMX54on5zoGnJLpPGjOtQ3IajbnWgXsG0KLZ25aNoV+sG4KLXAK2KTEb4pTtx8t6g9fcAG0JSNE8n36VwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/点赞小.png
// module id = iUCx
// module chunks = 1